import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Subscription} from 'rxjs';
import { MatCard, MatCardHeader, MatCardContent } from '@angular/material/card';
import { MessagesModule } from 'primeng/messages';
import { Message } from 'primeng/message';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  standalone: true,
  imports: [MatCard, MatCardHeader, MatCardContent, MessagesModule, Message],
})
export class ForbiddenComponent implements OnInit, OnDestroy {
  forbiddenType = 'disabled';
  module: string;
  paramsSubscription: Subscription;

  constructor(
    private readonly headerService: HeaderService,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.headerService.setTitle('Forbidden');

    this.paramsSubscription = this.route.paramMap.subscribe(params => {
      this.module = params.get('module');
    });

    this.forbiddenType = this.route.snapshot.queryParams['type'] || 'disabled';
  }

  ngOnDestroy(): void {
    this.paramsSubscription?.unsubscribe();
  }
}
